import { reportException } from "../../logging";
import { StorageService } from "../StorageService";
import {
  ADDING_CACHE_ERROR_CODE,
  INVALIDATING_CACHE_ERROR_CODE
} from "../loggingConstants";
import { STORAGE_KEYS } from "../constants";

function addMinutesToTime(minutes = 1) {
  return new Date().getTime() + minutes * 60000;
}
const CacheService = {
  addToCache({
    data,
    cacheName = "",
    ttl,
    storageType = STORAGE_KEYS.SESSION_STORAGE
  }) {
    try {
      let cache = StorageService.getFromStorage(cacheName, storageType);
      if (!cache) {
        cache = {};
      }
      const key = window.btoa(JSON.stringify(data.key));
      cache[key] = {};
      let cacheData = data.value;
      if (ttl) {
        cacheData = { ...cacheData, cacheExpiryFe: addMinutesToTime(ttl) };
      }
      cache[key] = cacheData;
      StorageService.setInStorage(cacheName, cache, storageType);
    } catch (err) {
      reportException({ error: err, errorCode: ADDING_CACHE_ERROR_CODE });
    }
  },
  checkInCache({
    key,
    cacheName = "",
    storageType = STORAGE_KEYS.SESSION_STORAGE
  }) {
    try {
      const cache = StorageService.getFromStorage(cacheName, storageType) || {};
      const cacheKeys = Object.keys(cache);
      const { length } = cacheKeys;

      const cacheKey = window.btoa(JSON.stringify(key));
      const storedObject = cache[cacheKey];
      const { cacheExpiryFe } = storedObject || {};
      if (cacheExpiryFe < new Date().getTime()) {
        delete cache[cacheKey];
        StorageService.setInStorage(cacheName, cache, storageType);
        return null;
      }
      if (storedObject) {
        return storedObject;
      }

      if (length === 10) {
        delete cache[cacheKeys[0]];
        StorageService.setInStorage(cacheName, cache, storageType);
      }
      return null;
    } catch (error) {
      return null;
    }
  },
  invalidateCache({ cacheName, storageType = STORAGE_KEYS.SESSION_STORAGE }) {
    try {
      StorageService.removeFromStorage(cacheName, storageType);
      return null;
    } catch (error) {
      reportException({ error, errorCode: INVALIDATING_CACHE_ERROR_CODE });
      console.log("error in invalidating cache", error);
    }
  }
};

export default CacheService;
